<template>
  <div class="game-preview">
    <Menu></Menu>
    <loading-state :state="state"></loading-state>
    <div v-if="state.isLoaded()" class="content">
      <game-head @publishLeaderboard="publishLeaderboard" :preview="preview"></game-head>
      <h1 class="left-part top-space">Matches</h1>
      <div class="content contest-box">
        <div class="matches contest-box-inner">
          <div
            v-for="match in preview.matches"
            :key="match.match.key"
            class="match-mini no-space"
          >
            <a class="clean" :href="match.match.link" target="window">
              <div class="teams">
                <div class="team">{{match.match.title}}</div>
              </div>
            </a>
            <div class="info">
              <b class="time">{{match.match.startAt | relativeShortDateTime}}</b>
              <p class="subtitle silent top-space">{{match.match.subtitle}} - {{match.match.season_name}}</p>
            </div>
          </div>
          <ParticipantsPreview :preview="preview"/>
        </div>
      </div>
      <div class="contest-box brought-users">
        <div class="contest-box-inner">
          <h3>Bot Users</h3>
          <el-input placeholder="Ex: 5" v-model="userCount"></el-input>
          <button class="change-btn" @click="AddUsers">Add</button>
          <loading-state :state="contestState"></loading-state>
        </div>
      </div>
      <button class="confirm-btn" @click="simulateMatch">Simulate</button>
    </div>
  </div>
</template>
<script>
import { DataState } from '@/state'
import { GamePreview } from '@/models/fantasygame/core'
import GameHead  from '@/components/fantasyconsole/GameHead'
import ParticipantsPreview from '@/components/fantasygame/ParticipantsPreview'
import { Game } from '@/models/fantasyconsole/game'

export default {
  components: {
    GameHead,
    ParticipantsPreview
  },

  data () {
    return {
      contestKey: this.$route.params.contestKey,
      gameKey: this.$route.params.gameKey,
      preview: null,
      contest: null,
      state: DataState.newLoading(),
      contestState: DataState.newNotInit(),
      enableCount: false,
      userCount: null
    }
  },
  watch: {
    '$route' (to, from) {
      if (to.params.gameKey !== from.params.gameKey) {
        this.prepareToReopen()
        this.onViewOpenned()
      } else {
        this.refreshView()
      }
    }
  },

  mounted () {
    this.onViewOpenned()
  },

  methods: {
    onViewOpenned () {
      this.contestKey = this.$route.params.key
      this.gameKey = this.$route.params.gameKey

      GamePreview.fetch(this.gameKey).then((resp) => {
        this.preview = resp
        this.state.changeToLoaded()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },

    prepareToReopen () {
      this.preview = null
      this.contest = null
      this.state = DataState.newLoading()
      this.contestState = DataState.newNotInit()
    },

    refreshView () {

    },

    publishLeaderboard () {
       Game.publishLeaderboard(this.preview.game.key).then((resp) => {
        if (resp.msg) {
          this.$notify({
            title: 'Success',
            message: resp.msg,
            type: 'success'
          })
        }
        this.onViewOpenned()
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },

    simulateMatch () {
      this.contestKey = this.$route.params.key
      this.gameKey = this.$route.params.gameKey
      Game.simulateMatch(this.gameKey).then((resp) => {
        if (resp.error) {
           this.$notify({
            title: 'Error',
            message: resp.error,
            type: 'error'
          });
        } else {
          this.$notify({
            title: 'Success',
            message: resp.msg,
            type: 'success'
          });
          this.$router.push({ name: 'FGGame', params: { 'contestKey':  this.contestKey, 'gameKey': this.gameKey } })
        }
      }).catch((error) => {
        this.state.changeToError(error)
      })
    },

    AddUsers () {
      this.contestState.changeToLoading()
      let payload = {
        'game_key': this.gameKey,
        'users_count': this.userCount
      }
      Game.AddUsers(payload).then((resp) => {
        if (resp.msg) {
          this.$notify({
            title: 'Success',
            message: resp.msg,
            type: 'success'
          });
          this.userCount = null
          this.contestState.changeToLoaded()
        }
      }).catch((error) => {
        this.contestState.changeToError(error)
      })
    }
  }
}
</script>